import React from "react";
import {
  Spin,
  Divider,
  Row,
  Col
} from "antd";
import global from "../../../common/utility/global";
import Header from "../../../components/Header";
import Filters from "../DashboardProducto/Filters";
import anioMock from '../../../common/mock/anioMock';
import mesMock from '../../../common/mock/mesMock';
import GraficoTotalVentas from "./GraficoTotalVentas";
import GraficoRankingTotalVentas from "./GraficoRankingTotalVentas";
import GraficoRankingCantidadVendida from "./GraficoRankingCantidadVendida";
import GraficoCantidadVendida from "./GraficoCantidadVendida";
import GraficoTotalVentasMensual from "./GraficoTotalVentasMensual";
import comprobanteService from "../../../service/ventas/comprobanteService";

export default class Index extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      anios: anioMock.values,
      meses: mesMock.values,
      filter: {
        anioInicio: global.fetchCurrentYear(true),
        mesInicio: global.fetchCurrentMonth(true),
        anioFin: global.fetchCurrentYear(),
        mesFin: global.fetchCurrentMonth()
      },
      ///CLIENTE
      graficoTotalVentasMensual: {
        series: [],
        timeLine: []
      },
      graficoRankingTotalVentas: {
        series: [],
        productos: [],
      },
      graficoRankingCantidadVendida: {
        series: [],
        productos: [],
      },
      graficoTotalVentas: {
        series: [],
        productos: [],
      },
      graficoCantidadVendida: {
        series: [],
        productos: [],
      },
    };
  }

  handleChange = (property, value) => {
    const filter = { ...this.state.filter, [property]: value };
    this.setState({ filter });
  };

  handleClearFilters = () => {
    
    this.setState({
      fechaInicioStr: global.fetchCurrentDateStr(true),
      fechaFinStr: global.fetchCurrentDateStr(),
    });
  };

  handleGenerateReport = async (filter) => {
    this.setState({
      loading: true,
    });
    const response = await comprobanteService.dashboardProducto(filter);
    if (response !== undefined) 
    this.setState({
      graficoTotalVentasMensual: {
        series: response.dataGraficoTotalVentasMensual,
        timeLine: response.dataTimeLine,
      },
      graficoRankingTotalVentas: {
        series: response.dataGraficoRankingTotalVentas,
        productos: response.dataProductoCortoOrderTotal,
      },
      graficoRankingCantidadVendida: {
        series: response.dataGraficoRankingCantidadVendida,
        productos: response.dataProductoCortoOrderCantidad,
      },
      graficoTotalVentas: {
        series: response.dataGraficoTotalVentas,
        productos: response.dataProductoOrderTotal,
      },
      graficoCantidadVendida: {
        series: response.dataGraficoCantidadVendida,
        productos: response.dataProductoOrderCantidad,
      },
      loading: false
    });
  };

  async componentDidMount() {
    await this.handleGenerateReport(this.state.filter);
    this.setState({
      loading: false,
    });
  }

  render() {
    return (
      <div>
        <Header
          title="Dashboard de Ventas por Producto"
          onClearFilters={this.handleClearFilters}
          onSearch={() => this.handleGenerateReport(this.state.filter)}
        />
           <Divider />
        <Filters filter={this.state.filter} anios={this.state.anios} meses={this.state.meses} onChange={this.handleChange} />
      
        <Spin tip="Cargando..." size="large" spinning={this.state.loading}>
        <Row gutter={16}>
            <Col className="gutter-row" sm={24} md={24} lg={24}>
            <GraficoTotalVentasMensual
                  series={this.state.graficoTotalVentasMensual.series}
                  timeLine={
                    this.state.graficoTotalVentasMensual.timeLine
                  }
                />
            </Col>
        </Row>
        <Divider className="mb-20" /> 
        <Row gutter={16}>
            <Col className="gutter-row" sm={24} md={24} lg={24}>
                <GraficoRankingTotalVentas
                series={this.state.graficoRankingTotalVentas.series}
                productos={this.state.graficoRankingTotalVentas.productos}
              />
            </Col>
        </Row>
        <Divider className="mb-20" />
        <Row gutter={16}>
            <Col className="gutter-row" sm={24} md={24} lg={24}>
                <GraficoRankingCantidadVendida
                series={this.state.graficoRankingCantidadVendida.series}
                productos={this.state.graficoRankingCantidadVendida.productos}
              />
            </Col>
        </Row>
        <Divider className="mb-20" />
        <Row gutter={50}>
            <Col className="gutter-row" sm={24} md={12} lg={12}>
            <GraficoTotalVentas
                series={this.state.graficoTotalVentas.series}
                productos={this.state.graficoTotalVentas.productos}
              />
            </Col>
            <Col className="gutter-row" sm={24} md={12} lg={12}>
            <GraficoCantidadVendida
                series={this.state.graficoCantidadVendida.series}
                productos={this.state.graficoCantidadVendida.productos}
              />
            </Col>
        </Row>
        </Spin>
      </div>
    );
  }
}
